export const EVENTS = {
  HIRE_OPENED: 'HIRE_OPENED',
  VIEW_OPENED: 'VIEW_OPENED',
  APPLICATION_CREATE_STARTED: 'APPLICATION_CREATE_STARTED',
  APPLICATION_DETAILS_ADDED: 'APPLICATION_DETAILS_ADDED',
  APPLICATION_UPDATE_STARTED: 'APPLICATION_UPDATE_STARTED',
  APPLICATION_ATTACHMENT_UPLOAD_REQUESTED:
    'APPLICATION_ATTACHMENT_UPLOAD_REQUESTED',
  APPLICATION_ATTACHMENT_UPLOAD_FAILURE_ACKNOWLEDGED:
    'APPLICATION_ATTACHMENT_UPLOAD_FAILURE_ACKNOWLEDGED',
  APPLICATION_ATTACHMENT_UPLOAD_SUCCESS_ACKNOWLEDGED:
    'APPLICATION_ATTACHMENT_UPLOAD_SUCCESS_ACKNOWLEDGED',
  APPLICATION_VIDEO_UPLOAD_SUCCESS_ACKNOWLEDGED:
    'APPLICATION_VIDEO_UPLOAD_SUCCESS_ACKNOWLEDGED',
  APPLICATION_VIDEO_UPLOAD_FAILURE_ACKNOWLEDGED:
    'APPLICATION_VIDEO_UPLOAD_FAILURE_ACKNOWLEDGED',
  APPLICATION_VIDEO_VIEWED: 'APPLICATION_VIDEO_VIEWED',
  APPLICATION_QUESTION_SUBMITTED: 'APPLICATION_QUESTION_SUBMITTED',
  EMPLOYEE_ADD_STARTED: 'EMPLOYEE_ADD_STARTED',
  JOB_UPDATE_REQUESTED: 'JOB_UPDATE_REQUESTED',
  JOB_CREATE_SUCCESS_ACKNOWLEDGED: 'JOB_CREATE_SUCCESS_ACKNOWLEDGED',
  JOB_CREATE_FAILURE_ACKNOWLEDGED: 'JOB_CREATE_FAILURE_ACKNOWLEDGED',
  CAREERS_PAGE_OPENED: 'CAREERS_PAGE_OPENED',
  CAREERS_PAGE_TAB_OPENED: 'CAREERS_PAGE_TAB_OPENED',
  EMPLOYEE_ONBOARDING_ADD_STARTED: 'EMPLOYEE_ONBOARDING_ADD_STARTED',
  CANDIDATE_UPDATE_REQUESTED: 'CANDIDATE_UPDATE_REQUESTED',
  CANDIDATE_UPDATE_SUCCESS_ACKNOWLEDGED:
    'CANDIDATE_UPDATE_SUCCESS_ACKNOWLEDGED',
  CANDIDATE_UPDATE_FAILURE_ACKNOWLEDGED:
    'CANDIDATE_UPDATE_FAILURE_ACKNOWLEDGED',
  CANDIDATE_DELETE_STARTED: 'CANDIDATE_DELETE_STARTED',
  CANDIDATE_DELETE_REQUESTED: 'CANDIDATE_DELETE_REQUESTED',
  CANDIDATE_DELETE_SUCCESS_ACKNOWLEDGED:
    'CANDIDATE_DELETE_SUCCESS_ACKNOWLEDGED',
  CANDIDATE_DELETE_FAILURE_ACKNOWLEDGED:
    'CANDIDATE_DELETE_FAILURE_ACKNOWLEDGED',
  CAREERS_PAGE_UPDATE_STARTED: 'CAREERS_PAGE_UPDATE_STARTED',
  CAREERS_PAGE_UPDATE_REQUESTED: 'CAREERS_PAGE_UPDATE_REQUESTED',
  CAREERS_PAGE_UPDATE_SUCCESS_ACKNOWLEDGED:
    'CAREERS_PAGE_UPDATE_SUCCESS_ACKNOWLEDGED',
  CAREERS_PAGE_UPDATE_FAILURE_ACKNOWLEDGED:
    'CAREERS_PAGE_UPDATE_FAILURE_ACKNOWLEDGED',
  CANDIDATE_VIEW_OPENED: 'CANDIDATE_VIEW_OPENED',
  CAREERS_PAGE_SHARE_SELECTED: 'CAREERS_PAGE_SHARE_SELECTED',
  JOB_LISTINGS_TAB_OPENED: 'JOB_LISTINGS_TAB_OPENED',
  JOB_SETTINGS_UPDATE_REQUESTED: 'JOB_SETTINGS_UPDATE_REQUESTED',
  JOB_SETTINGS_UPDATE_SUCCESS_ACKNOWLEDGED:
    'JOB_SETTINGS_UPDATE_SUCCESS_ACKNOWLEDGED',
  JOB_SETTINGS_UPDATE_FAILURE_ACKNOWLEDGED:
    'JOB_SETTINGS_UPDATE_FAILURE_ACKNOWLEDGED',
  JOB_CREATE_STARTED: 'JOB_CREATE_STARTED',
  JOB_CREATE_REQUESTED: 'JOB_CREATE_REQUESTED',
  JOB_PUBLISH_SUCCESS_ACKNOWLEDGED: 'JOB_PUBLISH_SUCCESS_ACKNOWLEDGED',
  JOB_PUBLISH_FAILURE_ACKNOWLEDGED: 'JOB_PUBLISH_FAILURE_ACKNOWLEDGED',
  JOB_PUBLISH_TO_JOB_BOARD_REQUESTED: 'JOB_PUBLISH_TO_JOB_BOARD_REQUESTED',
  JOB_PUBLISH_TO_JOB_BOARD_SUCCESS_ACKNOWLEDGED:
    'JOB_PUBLISH_TO_JOB_BOARD_SUCCESS_ACKNOWLEDGED',
  JOB_PUBLISH_TO_JOB_BOARD_FAILURE_ACKNOWLEDGED:
    'JOB_PUBLISH_TO_JOB_BOARD_FAILURE_ACKNOWLEDGED',
  JOB_UPDATE_STARTED: 'JOB_UPDATE_STARTED',
  JOB_UPDATE_SUCCESS_ACKNOWLEDGED: 'JOB_UPDATE_SUCCESS_ACKNOWLEDGED',
  JOB_UPDATE_FAILURE_ACKNOWLEDGED: 'JOB_UPDATE_FAILURE_ACKNOWLEDGED',
  SETTINGS_TAB_OPENED: 'SETTINGS_TAB_OPENED',
  APPLICATION_CREATE_REQUESTED: 'APPLICATION_CREATE_REQUESTED',
  APPLICATION_CREATE_SUCCESS_ACKNOWLEDGED:
    'APPLICATION_CREATE_SUCCESS_ACKNOWLEDGED',
  APPLICATION_CREATE_FAILURE_ACKNOWLEDGED:
    'APPLICATION_CREATE_FAILURE_ACKNOWLEDGED',
  JOB_DESCRIPTION_GENERATE_REQUESTED: 'JOB_DESCRIPTION_GENERATE_REQUESTED',
  JOB_DESCRIPTION_GENERATE_SUCCESS_ACKNOWLEDGED:
    'JOB_DESCRIPTION_GENERATE_SUCCESS_ACKNOWLEDGED',
  JOB_DESCRIPTION_GENERATE_FAILURE_ACKNOWLEDGED:
    'JOB_DESCRIPTION_GENERATE_FAILURE_ACKNOWLEDGED',
  JOB_PROMOTE_STARTED: 'JOB_PROMOTE_STARTED',
  JOB_PROMOTE_REQUESTED: 'JOB_PROMOTE_REQUESTED',
  JOB_PROMOTE_SUCCESS_ACKNOWLEDGED: 'JOB_PROMOTE_SUCCESS_ACKNOWLEDGED',
  JOB_PROMOTE_FAILURE_ACKNOWLEDGED: 'JOB_PROMOTE_FAILURE_ACKNOWLEDGED',
  JOB_PROMOTE_UPDATE_STARTED: 'JOB_PROMOTE_UPDATE_STARTED',
  JOB_PROMOTE_UPDATE_REQUESTED: 'JOB_PROMOTE_UPDATE_REQUESTED',
  JOB_PROMOTE_UPDATE_SUCCESS_ACKNOWLEDGED:
    'JOB_PROMOTE_UPDATE_SUCCESS_ACKNOWLEDGED',
  JOB_PROMOTE_UPDATE_FAILURE_ACKNOWLEDGED:
    'JOB_PROMOTE_UPDATE_FAILURE_ACKNOWLEDGED',
  JOB_PROMOTE_END_REQUESTED: 'JOB_PROMOTE_END_REQUESTED',
  JOB_PROMOTE_END_SUCCESS_ACKNOWLEDGED: 'JOB_PROMOTE_END_SUCCESS_ACKNOWLEDGED',
  JOB_PROMOTE_END_FAILURE_ACKNOWLEDGED: 'JOB_PROMOTE_END_FAILURE_ACKNOWLEDGED',
  INTEGRATION_CONNECT_REQUESTED: 'INTEGRATION_CONNECT_REQUESTED',
  INTEGRATION_CONNECT_SUCCESS_ACKNOWLEDGED:
    'INTEGRATION_CONNECT_SUCCESS_ACKNOWLEDGED',
  INTEGRATION_CONNECT_FAILURE_ACKNOWLEDGED:
    'INTEGRATION_CONNECT_FAILURE_ACKNOWLEDGED',
  INTEGRATION_DISCONNECT_REQUESTED: 'INTEGRATION_DISCONNECT_REQUESTED',
  INTEGRATION_DISCONNECT_SUCCESS_ACKNOWLEDGED:
    'INTEGRATION_DISCONNECT_SUCCESS_ACKNOWLEDGED',
  INTEGRATION_DISCONNECT_FAILURE_ACKNOWLEDGED:
    'INTEGRATION_DISCONNECT_FAILURE_ACKNOWLEDGED',
};

export const EVENT_SCREEN = {
  HIRE: 'HIRE',
  APPLICATION: 'APPLICATION',
  PEOPLE: 'PEOPLE',
  APPLICANTS: 'APPLICANTS',
  CAREERS_PAGE: 'CAREERS_PAGE',
  JOB_SETTINGS: 'JOB_SETTINGS',
  JOB_LISTINGS: 'JOB_LISTINGS',
  JOB_CREATE: 'JOB_CREATE',
  UNKNOWN_EVENT_SCREEN: 'UNKNOWN_EVENT_SCREEN',
  SCHEDULE: 'SCHEDULE',
  JOB_BOARD_SEEK: 'SEEK_MANAGEMENT',
};

export const EVENT_SOURCE = {
  GET_STARTED: 'Get started',
  APPLICATION_NAME: 'Your info- Name',
  APPLICATION_POSTCODE: 'Your info- Postcode',
  APPLICATION_CONTACT_DETAILS: 'Your info- Contact details',
  APPLICATION_WORKING_RIGHTS: 'Working rights',
  APPLICATION_VIDEO_QUESTIONS: 'Video questions',
  APPLICATION_REVIEW_EDIT_CONTACT_DETAILS: 'Review- Edit Contact details',
  APPLICATION_REVIEW_EDIT_RESUME: 'Review- Edit Resume',
  APPLICATION_REVIEW_EDIT_WORKING_RIGHTS: 'Review- Edit Working rights',
  APPLICATION_REVIEW_EDIT_ADDITIONAL: 'Review- Edit Additional questions',
  APPLICATION_REVIEW_EDIT_VIDEO_QUESTIONS: 'Review- Edit Video questions',
  APPLICATION_VIDEO_QUESTIONS_COMPANY: 'Video questions- Company video',
  APPLICATION_REVIEW_SUBMIT: 'Review-Submit',
  CV_UPLOADED: 'Your CV- Uploaded',
  CV_ADD_FILES: 'Your CV- Add files',
  ADDITIONAL_QUESTIONS: 'Additional questions- Question ',
  PEOPLE_TAB: 'People tab- Deputy Hire launch',
  HEAD_TO_CAREER_PAGE: 'Head to Careers page',
  CREATE_JOB_LISTING: 'Create job listing',
  SHARE_CAREERS_PAGE: 'Share Careers page',
  HIRE_ADD_TEAM_MEMBER: 'Hire: Add Team Member',
  HIRE_ONBOARD_TEAM_MEMBER: 'Hire: Onboard Team Member',
  UPDATE_APPLICANT_STAGE: "Updating Applicant's stage",
  ALL_LOCATION_DROPDOWN: 'All locations dropdown',
  ALL_JOB_LISTING_DROPDOWN: 'All job listings dropdown',
  FILTER_MODAL: 'Filter modal',
  EDIT_HERO_SECTION: 'Edit hero section',
  EDIT_ABOUT_SECTION: 'Edit about section',
  PUBLISH_HERO_SECTION: 'Publish changes to hero section',
  PUBLISH_ABOUT_SECTION: 'Publish changes to about section',
  OPEN_NEW_TAB: 'Open in new tab',
  LINK_COPIED: 'Link copied',
  MANAGE_LISTING: 'Manage listings',
  FACEBOOK: 'Facebook',
  TWITTER: 'Twitter',
  QR_CODE: 'QR code',
  QR_POSTER: 'QR poster',
  LINKEDIN: 'Linkedin',
  NEWSFEED: 'Newsfeed',
  SAVE: 'Save',
  PUBLISH: 'Publish',
  SAVE_CHANGE: 'Save change',
  CREATE_LISTING: 'Create listing',
  MENU_OPTIONS_EDIT: 'Kebab menu options- Edit',
  MENU_OPTIONS_DUPLICATE: 'Kebab menu options- Duplicate',
  MENU_OPTIONS_ARCHIVE: 'Kebab menu options- Archive',
  MENU_OPTIONS_UNARCHIVE: 'Kebab menu options- Unarchive',
  MENU_OPTIONS_DELETE: 'Kebab menu options- Delete',
  EDIT: 'Edit',
  DUPLICATE: 'Duplicate',
  ARCHIVE: 'Archive',
  UNARCHIVE: 'Unarchive',
  DELETE: 'Delete',
  JOB_CREATE_SETTING_LINK: 'Job create-Settings hyperlink',
  VIEW_LIVE_LISTING: 'View live listing',
  GETTING_STARTED_VIDEO: 'Getting started video',
  HELP_CENTRE: 'Help Centre',
  GIVE_US_FEEDBACK: 'Give us feedback',
  HELP_BANNER_HIRE_A_NEW_PERSON: 'Help banner - Hire a new person',
  HELP_BANNER_SEE_HOW_IT_WORKS: 'Help banner - See how it works',
  PUBLISHED_SHIFT_HIRE_LINK: 'Published shift - Try Deputy hire',
  GENERATE_JOB_DESCRIPTION: 'Generate job description',
  HIRE_SETTINGS_PAGE: 'Hire settings page',
  PUBLISH_JOB_MODAL: 'Publish job modal',
  PROMOTE_JOB_MODAL: 'Promote',
  PROMOTE_EDIT_JOB_MODAL: 'Edit promotion',
  CONNECT_SEEK_ACCOUNT: 'Connect Seek account',
  CHANGE_AD_TYPE: 'Change ad type',
  READ_ONLY_EDIT: 'Read only page - Edit',
  DELETE_CANDIDATE: 'Permanently delete',
};

export const EVENT_NAME = {
  JOB_LISTINGS_PAGE_OPENED: 'Job listings page opened',
  CANDIDATE_JOBS_PAGE_OPENED: 'Candidate jobs page opened',
  SETTINGS_PAGE_OPENED: 'Settings page opened',
};

export const APPLICANT_STATUS_TYPE = {
  UNKNOWN_UPDATE_TYPE: 'UNKNOWN_UPDATE_TYPE',
  NEW: 'NEW',
  LONGLISTED: 'LONGLISTED',
  CONTACTED: 'CONTACTED',
  SHORTLISTED: 'SHORTLISTED',
  INTERVIEWING: 'INTERVIEWING',
  OFFER: 'OFFER',
  HIRED: 'HIRED',
  NOT_SUITABLE: 'NOT_SUITABLE',
};

export const JOB_UPDATE_TYPE = {
  UNKNOWN_UPDATE_TYPE: 'UNKNOWN_UPDATE_TYPE',
  EDIT: 'EDIT',
  ARCHIVE: 'ARCHIVE',
  DUPLICATE: 'DUPLICATE',
  UNARCHIVE: 'UNARCHIVE',
  DELETE: 'DELETE',
};

export const JOB_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISH: 'PUBLISH',
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  DELETE: 'DELETE',
};

// values are the event spec's job.JobBoard enum names
export const APPLICATION_SOURCE = {
  JOB_BOARD_DEPUTY: 'JOB_BOARD_DEPUTY',
  JOB_BOARD_SEEK: 'JOB_BOARD_SEEK',
  JOB_BOARD_JOB_TARGET: 'JOB_BOARD_JOBTARGET',
};

export const JOB_TARGET_APPLICATION_TYPE = {
  APPLY_VIA_JTEASY: 'APPLY_VIA_JTEASY',
  APPLY_VIA_DEPUTY: 'APPLY_VIA_DEPUTY',
};

export const CANDIDATE_UPDATE_TYPE = {
  UNKNOWN_ACTION: 'UNKNOWN_ACTION',
  UPDATE_STATUS: 'UPDATE_STATUS',
  UPDATE_CONTACT: 'UPDATE_CONTACT',
};
